import Api from '../../../services';

export const createListing = () => {
  return (dispatch) => {
    return Api.hostApi.listings.createListing().then((response) => {
      dispatch({
        type: 'CREATE_LISTING',
        data: response,
      });
      return response;
    });
  };
};

export const updateListing = (id, data) => {
  return (dispatch) => {
    return Api.hostApi.listings.updateListing(id, data).then((response) => {
      dispatch({
        type: 'UPDATE_LISTING',
        data: response,
      });
      return response;
    });
  };
};

export const updateListingEntities = (id, data) => {
  return (dispatch) => {
    return Api.hostApi.listings.updateListingEntities(id, data).then((response) => {
      dispatch({
        type: 'UPDATE_LISTING_ENTITIES',
        data: response,
      });
      return response;
    });
  };
};

export const uploadListingImage = (id, data) => {
  return (dispatch) => {
    return Api.hostApi.listings.uploadListingImage(id, data)
      .then((response) => {
        dispatch({
          type: 'UPDATE_LISTING_IMAGE',
          data: response,
        });
        return response;
      });
  };
};

export const deleteListingImage = (id, imageId) => {
  return (dispatch) => {
    return Api.hostApi.listings.deleteListingImage(id, imageId)
      .then((response) => {
        dispatch({
          type: 'DELETE_LISTING_IMAGE',
          data: response,
        });
        return response;
      });
  };
};

export const updateListingAvailability = (data) => {
  return (dispatch) => {
    return Api.hostApi.listings.updateListingAvailability(data).then((response) => {
      dispatch({
        type: 'UPDATE_LISTING_AVAILABILITY',
        data: response,
      });
      return response;
    });
  };
};

export const getHostListings = (params) => {
  return (dispatch) => {
    return Api.hostApi.listings.getHostListings(params).then((response) => {
      dispatch({
        type: 'GET_HOST_LISTINGS',
        data: response,
      });
      return response;
    });
  };
};

export const deleteHostListing = (listingId) => {
  return (dispatch) => {
    return Api.hostApi.listings.deleteHostListing(listingId).then((response) => {
      dispatch({
        type: 'DELETE_HOST_LISTING',
        data: response,
      });
      return response;
    });
  };
};

export const getHostListingDetails = (listingId) => {
  return (dispatch) => {
    return Api.hostApi.listings.getHostListingDetails(listingId).then((response) => {
      dispatch({
        type: 'GET_HOST_LISTING_DETAILS',
        data: response,
      });
      return response;
    });
  };
};

export const submitListing = (id) => {
  return (dispatch) => {
    return Api.hostApi.listings.submitListing(id).then((response) => {
      dispatch({ type: 'SUBMIT_LISTING' });
      return response;
    });
  };
};

export const uploadPolicyFile = (id, data) => {
  return (dispatch) => {
    return Api.hostApi.listings.uploadPolicyFile(id, data).then((response) => {
      dispatch({ type: 'UPLOAD_POLICY_FILE' });
      return response;
    });
  };
};

export const getListingBlockTimes = (data) => {
  return (dispatch) => {
    return Api.hostApi.listings.getListingBlockTimes(data).then((response) => {
      dispatch({
        type: 'GET_LISTING_BLOCK_TIMES',
        data: response,
      });
      return response;
    });
  };
};

export const createListingBlockTime = (params) => {
  return (dispatch) => {
    return Api.hostApi.listings.createListingBlockTime(params).then((response) => {
      dispatch({
        type: 'CREATE_LISTING_BLOCK_TIME',
        data: response,
      });
      return response;
    });
  };
};

export const deleteListingBlockTime = (blockTimeId) => {
  return (dispatch) => {
    return Api.hostApi.listings.deleteListingBlockTime(blockTimeId).then((response) => {
      dispatch({
        type: 'DELETE_LISTING_BLOCK_TIME',
        data: response,
      });
      return response;
    });
  };
};

export const getListingBookings = (id, params) => {
  return (dispatch) => {
    return Api.hostApi.listings.getListingBookings(id, params).then((response) => {
      dispatch({ type: 'GET_LISTING_BOOKINGS', data: response });
      return response;
    });
  };
};

export const getBookingsCalendar = (listingId, params) => {
  return (dispatch) => {
    return Api.hostApi.listings.getBookingsCalendar(listingId, params).then((response) => {
      dispatch({
        type: 'GET_BOOKINGS_CALENDAR',
        data: response,
      });
      return response;
    });
  };
};
